document.addEventListener('DOMContentLoaded', function () {
        var inputs = document.querySelectorAll('[data-az-search]');
            if (!inputs.length) return;
            var grid = document.getElementById('product-grid');
    var items = grid ? grid.querySelectorAll('[data-az-title]') : [];
    var emptyMessage = null;
    function applyFilter(query) {
    var q = query.trim().toLowerCase();
    var visibleCount = 0;
    items.forEach(function (item) {
    var title = (item.getAttribute('data-az-title') || '').toLowerCase();
    var show = q === '' || title.indexOf(q) !== -1;
    item.style.display = show ? '' : 'none';
    if (show) visibleCount++;
    });
    if (grid) {
    if (visibleCount === 0) {
    if (!emptyMessage) {
    emptyMessage = document.createElement('p');
    emptyMessage.className = 'az-filter-empty';
    emptyMessage.textContent = 'No products found.';
    grid.parentNode.insertBefore(emptyMessage, grid.nextSibling);
    }
    emptyMessage.style.display = '';
    } else if (emptyMessage) {
    emptyMessage.style.display = 'none';
    }
    }
    }
inputs.forEach(function (input) { input.addEventListener('input', function () { inputs.forEach(function (other) { if (other !== input) { other.value = input.value; } }); applyFilter(input.value); }); });
        var params = new URLSearchParams(window.location.search);
            var qParam = params.get('q');
                if (qParam) {
                    inputs.forEach(function (input) { input.value = qParam; }); applyFilter(qParam);
                            }
    });